import { z } from "zod";

// A patient's credit (stored value) balance summary. Tolerant parsing — the
// backend may omit fields for a patient with no account yet.
export const CreditSummarySchema = z.object({
  hasAccount: z.boolean().optional().default(false),
  accountId: z.string().nullable().optional(),
  balanceCents: z.number().optional().default(0),
  reservedCents: z.number().optional().default(0),
  availableCents: z.number().optional().default(0),
  currency: z.string().optional().default("CAD"),
  status: z.string().nullable().optional(),
  updatedAt: z.number().nullable().optional(),
});
export type CreditSummary = z.infer<typeof CreditSummarySchema>;

export const CreditSummaryResponseSchema = z.object({
  success: z.boolean(),
  credit: CreditSummarySchema,
});

// The minted/updated account (we only read the balance on the FE).
const CreditAccountSchema = z
  .object({ balanceCents: z.number().optional() })
  .passthrough();

// issue-stripe / finalize: either the top-up succeeded synchronously, or a 3DS
// challenge is required (the FE confirms the clientSecret then finalises).
export const IssueCreditResponseSchema = z.object({
  success: z.boolean(),
  status: z.enum(["succeeded", "requires_action"]),
  account: CreditAccountSchema.nullable().optional(),
  clientSecret: z.string().nullable().optional(),
  paymentIntentId: z.string().optional(),
});
export type IssueCreditResponse = z.infer<typeof IssueCreditResponseSchema>;
